export const EVENT_CONNECTION = `
	query eventConnection($event_id: Uint) {
		eventConnection(event_id: $event_id) {
			id
			active
			point_value
			settings
		}
	}
`;

export const EVENT_CONNECTIONS = `
	query eventConnections($event_id: Uint, $attendee_id: Uint, $offset: Uint, $items_per_page: Uint) {
		eventConnections(event_id: $event_id, attendee_id: $attendee_id, offset: $offset, items_per_page: $items_per_page) {
			nodes {
				id
				attendees {
					nodes {
						id
						email
						first_name
						last_name
					}
				}
				created_at
			}
			page_info {
				has_next_page
				total_count
			}
		}
	}
`;
